import { useState } from "react";
import timeService from "../../../../../../services/timeService";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";

function AddTime(props) {
  const { expedienteId, onAddTime } = props;

  const [time, setTime] = useState("");
  const [description, setDescription] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [successSB, setSuccessSB] = useState(false);
  const closeSuccessSB = () => setSuccessSB(false);
  const [errorSB, setErrorSB] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const closeErrorSB = () => setErrorSB(false);

  const addTime = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const obj = {
      expedienteId,
      time,
      description
    };

    const data = await timeService.createTime(obj);
    setErrorMessage(data);
    if (data === 200) {
      setSuccessSB(true);
      setTime("");
      setDescription("");
      if (onAddTime){
        onAddTime();
      }
    } else {
      setErrorSB(true);
    }
    setSubmitting(false);
  };

  const renderSuccessSB = (
    <MDSnackbar
      color="success"
      icon="check"
      title="Registro agregado correctamente!"
      content="Registro agregado correctamente!"
      dateTime=""
      open={successSB}
      onClose={closeSuccessSB}
      close={closeSuccessSB}
    />
  );

  const renderErrorSB = (
    <MDSnackbar
      color="error"
      icon="warning"
      title="Error"
      content={errorMessage}
      dateTime=""
      open={errorSB}
      onClose={closeErrorSB}
      close={closeErrorSB}
      bgWhite
    />
  );

  return (
    <Card>
      <MDBox position="relative" p={1}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={12}>
          <form onSubmit={addTime}>
            <Accordion
              style={{ boxShadow: "none" }}
              sx={{
                backgroundColor: (theme) =>
                  theme.palette.mode === "dark"
                    ? theme.palette.action.hover
                    : "transparent !important",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <MDTypography
                  display="block"
                  variant="button"
                  fontWeight="regular"
                  // color="text"
                >
                  Registrar tiempo utilizado
                </MDTypography>
              </AccordionSummary>
              <AccordionDetails>
                <MDBox>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <MDInput
                        fullWidth
                        type="text"
                        label="Tiempo"
                        value={time}
                        required
                        onChange={(event) => {
                          setTime(event.target.value);
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <MDInput
                        fullWidth
                        type="text"
                        label="Descripción"
                        value={description}
                        required
                        onChange={(event) => {
                          setDescription(event.target.value);
                        }}
                      />
                    </Grid>
                  </Grid>
                </MDBox>
              </AccordionDetails>
              <AccordionActions>
                <MDButton variant="gradient" color="success" type="submit" disabled={submitting}>
                  Agregar
                </MDButton>
                {renderSuccessSB}
                {renderErrorSB}
              </AccordionActions>
            </Accordion>
          </form>
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}

AddTime.propTypes = {
    expedienteId: PropTypes.number.isRequired,
    onAddTime: PropTypes.func,
};

export default AddTime;